import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { smoothScrollToTop } from "../../lib/scrollToTop";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    smoothScrollToTop(0.55);
  }, [pathname]);

  return null;
}
